<template>
    <div id="manual-insurance-patient-selection-container">
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:Label="$tc('Insurance.Insurance', 1)"
                    v-bind:ModelCode="insuranceCodeVModel.code"
                    v-bind:ModelDescription="insuranceCodeVModel.description"
                    v-bind:RefCode="'InsuranceCode'"
                    v-bind:Api="'Insurances/Lookup'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$tc('Insurance.Insurance', 2)"
                    :GetValues="getInsuranceValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :ServerSidePagination="true"
                    v-bind:Fields="insuranceLookupFields"
                    :isRequired="true"
                    :isValid="insuranceCodeValid"
                    :IsDisabled="searching || readOnly"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="parameters.dateFrom"
                    @input="dateFromChanged($event)"
                    :Id="'payment-date-from'"
                    :Type="'date'"
                    :isConfirm="false"
                    :ReadOnly="searching || readOnly"
                    :isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="parameters.dateTo"
                    @input="dateToChanged($event)"
                    :Id="'payment-date-to'"
                    :Type="'date'"
                    :isConfirm="false"
                    :ReadOnly="searching || readOnly"
                    :isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('dailyServiceCharge.DisplayOpt')"
                    v-bind:Options="displayOptions"
                    v-bind:Model.sync="displayOptionVModel"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownDisplayOptions"
                    :IsDisabled="searching || readOnly"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    :Label="$t('Shared.HZBalance')"
                    :Name="'checkbox-is-hide-void'"
                    :ClassProp="'AlignCheck'"
                    :CheckedValue="true"
                    :UncheckedValue="false"
                    v-model="parameters.isHideVoid"
                    :isReadOnly="searching || readOnly"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdCheckBox
                    :Label="$t('PostPayment.Manual.IncludeTransaction')"
                    :Name="'checkbox-include-transaction'"
                    :ClassProp="'AlignCheck'"
                    :CheckedValue="true"
                    :UncheckedValue="false"
                    v-model="parameters.incTransaction"
                    :isReadOnly="searching || readOnly"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.Patients')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdButton
                    v-bind:Label="$t('PatientsList.addPatient')"
                    v-bind:ClassProp="
                        false
                            ? 'btn btn-primary my-3 btn-block'
                            : 'btn btn-primary my-3 btn-block btn-login'
                    "
                    v-on:click="AddPatientHandler"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-bind:Name="'btn_add_patient'"
                    :isReadOnly="addPatientButtonEnabled"
                >
                </MdButton>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" lg="12" md="12">
                <MdTablePaginationClient
                    v-bind:fields="fields"
                    v-bind:items="patientSelected"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="false"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                    :RowClick="rowClick"
                    :customActionButtons="customActionButtons"
                >
                </MdTablePaginationClient>
            </b-col>
        </b-row>
        <insurance-patient-selection-modal
            :visible.sync="patientSelectionVisible"
            :insurance-info="insuranceCodeVModel"
            :date-from="parameters.dateFrom"
            :date-to="parameters.dateTo"
            @ok="handleOk"
        ></insurance-patient-selection-modal>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import InsurancePatientSelectionModal from './insPatientSelectionModal.vue';
import Utils from '@/common/utils.js';

export default {
    name: 'InsurancePatientSelection',
    components: { InsurancePatientSelectionModal },
    props: {
        value: {
            type: Object,
            required: true
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        deleteActionDisabled: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            parameters: this.value || {
                insuranceCode: '',
                insuranceName: '',
                dateTo: null,
                dateFrom: null,
                displayOption: 1,
                isHideVoid: false,
                incTransaction: false
            },
            insuranceCodeVModel: { code: '', description: '' },
            insuranceLookupFields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description')
                },
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.Code')
                }
            ],
            searching: false,
            isDateFromValid: true,
            isDateToValid: true,
            selectPlaceholder: this.$t('Shared.SelectOptions'),
            displayOptions: EnumService.PaymentPostDisplayOption,
            displayOptionVModel: 1,
            patientSelectionVisible: false,
            showMessageIsEmpty: true,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            fields: [
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left',
                    thStyle: { width: '75%' }
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-left',
                    thStyle: { width: '20%' }
                }
            ],
            patientSelected: [],
            insuranceCodeValid: true,
            customActionButtons: [
                {
                    id: 'delete-patient',
                    visible: true,
                    disabled: item => this.deleteActionDisabledHandler(item),
                    icon: 'med-bin',
                    handler: item => this.remove(item),
                    tooltip: this.$t('Shared.TitleDelete')
                }
            ]
        };
    },
    computed: {
        addPatientButtonEnabled() {
            return Utils.isNullOrEmptyString(this.parameters.insuranceCode);
        },
        totalRows() {
            return this.patientSelected.length;
        }
    },
    watch: {
        value(newValue) {
            this.parameters = newValue || {
                insuranceCode: '',
                insuranceName: '',
                dateTo: null,
                dateFrom: null,
                displayOption: 1,
                isHideVoid: false,
                incTransaction: false
            };
        }
    },
    methods: {
        getInsuranceValues(value) {
            this.parameters.insuranceCode = value ? value.code : null;
            this.parameters.insuranceName = value ? value.description : null;
            this.insuranceCodeVModel = value;
            this.patientSelected = [];
            this.$emit('input', this.parameters);
            this.$emit('patient-selected', {
                patientSelected: [],
                patientAppends: [],
                dateFrom: null,
                dateTo: null
            });
        },
        dateFromChanged(value) {
            this.parameters.dateFrom = value;
            this.$emit('input', this.parameters);
        },

        dateToChanged(value) {
            this.parameters.dateTo = value;
            this.$emit('input', this.parameters);
        },
        changeDropDownDisplayOptions(value) {
            if (value) {
                this.parameters.displayOption = value.value;
                this.$emit('input', this.parameters);
            } else {
                this.$nextTick(() => {
                    this.displayOptionVModel = this.parameters.displayOption;
                    this.$emit('input', this.parameters);
                });
            }
        },
        AddPatientHandler() {
            this.patientSelectionVisible = true;
        },
        handleOk({ selectedItems, dateFrom, dateTo }) {
            let dirty = false;
            const patientAppends = [];
            selectedItems.forEach(element => {
                const indexOf = this.patientSelected.findIndex(
                    patient => patient.patientCode === element.patientCode
                );

                if (indexOf === -1) {
                    this.patientSelected.push(element);
                    patientAppends.push(element);
                    dirty = true;
                }
            });

            if (dirty) {
                this.patientSelected.sort((a, b) => {
                    const x = a.patientName.toLowerCase();
                    const y = b.patientName.toLowerCase();
                    return x < y ? -1 : x > y ? 1 : 0;
                });
                this.$emit('patient-selected', {
                    patientSelected: this.patientSelected,
                    patientAppends: patientAppends,
                    dateFrom: dateFrom,
                    dateTo: dateTo
                });
            }
        },

        deleteActionDisabledHandler(item) {
            if (this.deleteActionDisabled) {
                return this.deleteActionDisabled(item);
            }

            return false;
        },

        remove(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('PostPayment.Manual.Title'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        const indexOf = this.patientSelected.findIndex(
                            patient => patient.patientCode === row.patientCode
                        );

                        if (indexOf !== -1) {
                            this.patientSelected.splice(indexOf, 1);
                            this.$emit('patient-removed', row.patientCode);
                        }
                    }
                });
        },

        validate_required() {
            this.insuranceCodeValid = !Utils.isNullOrEmptyString(this.parameters.insuranceCode);
            return this.insuranceCodeValid;
        },

        resetPatientList(items) {
            this.patientSelected = items;
            this.showMessageIsEmpty = items.length === 0;
        },

        resetDisplayOption(displayOption) {
            this.parameters.displayOption = displayOption ?? 1;
            const vmodel = this.displayOptions.find(x => x.value === this.parameters.displayOption);

            if (vmodel) {
                this.displayOptionVModel = displayOption;
            }
        },

        perPageFunction() {},
        pageChanged() {},
        rowClick() {}
    }
};
</script>
